<template>
  <div>
    <div class="child-bg-image">
      <div class="bg-image-section" />
      <div class="content-section d-dlex align-center">
        <check-out-notify-page />
      </div>
    </div>
  </div>
</template>

<script>
import CheckoutNotifyPage from '../Components/CheckoutNotifyPage.vue';
  export default {
    name: 'CheckoutNotification',
    components: {
      'check-out-notify-page': CheckoutNotifyPage,
    },
  };
</script>

<style scoped>
.content-section {
  padding: 0 !important;
}
</style>
